import type { DetailsSummaryADFQuery_detailsLines_detailLines } from '../queries/__types__/DetailsSummaryADFQuery.ts';

import { extractAllLabelsText } from './extractAllLabelsText.ts';

/**
  Retrieves the key values from the detailLine object to use for comparison based on the column being sorted
*/
export const getColumnComparisons = (
	a: DetailsSummaryADFQuery_detailsLines_detailLines,
	b: DetailsSummaryADFQuery_detailsLines_detailLines,
	sortColumn: string,
): string[] | number[] => {
	switch (sortColumn) {
		case 'showCommentsCount':
			return [a.commentsCount, b.commentsCount];
		case 'pageTitle':
			return [a.title, b.title];
		case 'showCreator':
			return [a.creator?.name || '', b.creator?.name || ''];
		case 'showLastModified':
			return [a.lastModified?.sortableDate || '', b.lastModified?.sortableDate || ''];
		case 'showLikesCount':
			return [a.reactionsCount, b.reactionsCount];
		case 'showPageLabels':
			return [extractAllLabelsText(a.labels), extractAllLabelsText(b.labels)];
		case 'showUnresolvedCommentsCount':
			return [a.unresolvedCommentsCount, b.unresolvedCommentsCount];
		default:
			// prevents sort if given a bad sort column value
			return [1, 1];
	}
};
